/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Grid, Icon, MenuItem, Paper, Select, TextField, Typography, useTheme, alpha } from '@mui/material';
import { Environment } from '../../environment';
import { AutoCompleteParceiroListagem } from '../../forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface IFerramentasDaListagemProps {
  textoDaBusca?: string;
  textoDoSelect?: string;
  textoDoStatus?: string;
  textonome?: string;
  dataInicial?: string;
  dataFinal?: string;
  mostrarInputData?: boolean;
  textSelectFalse?: string;
  textSelectTrue?: string;
  mostrarInputBusca?: boolean;
  mostrarAutoComplete?: boolean;
  disbilitarBaixar?: boolean;
  disbilitarDesconto?: boolean;
  disbilitarSalvar?: boolean;
  disbilitarCheque?: boolean;
  disbilitarImprimir?: boolean;
  aoMudarDataInicial?: (novoTexto: string) => void;
  aoMudarDataFinal?: (novoTexto: string) => void;
  aoMudarTextoDeBusca?: (novoTexto: string) => void;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
  aoMudarTextoDoStatus?: (novoTextoDoStatus: string) => void;
  aoMudarTextoDoParceiro?: (novoTextoselect: string, texto1: string) => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  mostrarBotaoCheque?: boolean;
  mostrarInputBasicSelect?: boolean
  aoClicarEmNovo?: () => void;
  aoClicarEmDesconto?: () => void;
  aoClicarEmSalvar?: () => void;
  aoClicarEmBaixa?: () => void;
  aoClicarEmCheque?: () => void;
  aoClicarEmImpressao?: () => void;
}

export const FerramentasDaListagemFinanceiro: React.FC<IFerramentasDaListagemProps> = ({
  textoDaBusca = '',
  textoDoSelect = '',
  textonome='',
  dataInicial = '',
  dataFinal = '',
  aoMudarDataInicial, 
  aoMudarDataFinal,
  aoMudarTextoDeBusca,
  aoMudarTextoDoSelect,
  aoMudarTextoDoParceiro, 
  mostrarInputBusca = false,
  mostrarBotaoCheque = false,
  mostrarAutoComplete = false,
  mostrarInputBasicSelect = false,
  aoClicarEmNovo,
  aoClicarEmBaixa,
  aoClicarEmCheque,
  aoClicarEmImpressao,
  disbilitarBaixar,
  disbilitarCheque,
  disbilitarImprimir,
  mostrarInputData = false,
}) => {
  const theme = useTheme();
  const partesDaDataInicial = dataInicial.split('/');
  const dataInicialFormatada = partesDaDataInicial[2] + '-' + partesDaDataInicial[1] + '-' + partesDaDataInicial[0];
  const partesDaDataFinal = dataFinal.split('/');
  const dataFinalFormatada = partesDaDataFinal[2] + '-' + partesDaDataFinal[1] + '-' + partesDaDataFinal[0];

  const handleuuidparceiroNome = (nome: string | undefined) => {
    if (nome != null) {
      textonome = nome;
    }  
  };
  const handleuuidparceiro = (uuid: string | undefined) => {
    if (uuid != null) {
      aoMudarTextoDoParceiro?.(uuid, textonome);
    }  
  };
  return (
    <Box
      gap={1}
      marginX={2}
      padding={1} 
      paddingX={2}
      display="flex"
      alignItems="center"
      component={Paper}
      sx={{
        backgroundColor: alpha(theme.palette.background.paper, 0.95),
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        boxShadow: theme.shadows[1],
        borderRadius: 2,
      }}
    >
      <Grid container item direction="row" spacing={1}> 
        <Grid item xs={12} sm={4} md={3} lg={2} xl={1.5}> 
          {mostrarInputBasicSelect && (  
            <Select
              fullWidth
              size='small'
              value={textoDoSelect}
              onChange={(event) => aoMudarTextoDoSelect?.(event.target.value)}
              sx={{
                backgroundColor: alpha(theme.palette.background.default, 0.6),
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: alpha(theme.palette.primary.main, 0.3),
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                  borderWidth: 2,
                }
              }}
            >
              <MenuItem value={'r.numerodoc'}>Numero</MenuItem>
              <MenuItem value={'parceiro'}>Parceiros</MenuItem>
              <MenuItem value={'data'}>Vencimento</MenuItem>
            </Select>  
          )} 
        </Grid>              
        {mostrarInputBusca && (
          <Grid item xs={12} sm={8} md={8} lg={8} xl={3}>  
            <TextField
              fullWidth
              size='small'
              value={textoDaBusca}
              placeholder={Environment.INPUT_DE_BUSCA}
              onChange={(e) => aoMudarTextoDeBusca?.(e.target.value)}
              sx={{
                backgroundColor: alpha(theme.palette.background.default, 0.6),
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: alpha(theme.palette.primary.main, 0.3),
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                  borderWidth: 2,
                }
              }}
            />
          </Grid>  
        )} 
        {mostrarAutoComplete && (
          <Grid item xs={12} sm={8} md={8} lg={4} xl={4}>                  
            <AutoCompleteParceiroListagem
              nome={handleuuidparceiroNome}
              uuidparceiro={handleuuidparceiro}
              isExternalLoading={false}
            />  
          </Grid>
        )} 
        {mostrarInputData && (
         <Grid item  xs={12} sm={12} md={8} lg={8} xl={8}>          
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker 
                sx={{ 
                  minWidth: 110, 
                  marginLeft:1, 
                  maxWidth: 150,
                  backgroundColor: alpha(theme.palette.background.default, 0.6),
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  }
                }}
                label="Data Inicial" 
                format='DD/MM/YYYY'
                defaultValue={dayjs()}
                value={dayjs(dataInicialFormatada)}
                onChange={(date: Dayjs | null) => {
                  const novoTexto = date ? date.format('DD/MM/YYYY') : '';
                  aoMudarDataInicial?.(novoTexto);
                }}
                slotProps={{
                  textField: {    
                    size:'small',
                  }
                }}
              />
              <DatePicker 
                sx={{ 
                  minWidth: 120, 
                  marginLeft:1, 
                  maxWidth: 150,
                  backgroundColor: alpha(theme.palette.background.default, 0.6),
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  }
                }}
                label="Data Final" 
                format='DD/MM/YYYY'
                defaultValue={dayjs()}
                value={dayjs(dataFinalFormatada)}
                onChange={(date: Dayjs | null) => {
                  const novoTexto = date ? date.format('DD/MM/YYYY') : '';
                  aoMudarDataFinal?.(novoTexto);
                }}
                slotProps={{
                  textField: {    
                    size:'small',
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>
        )}  
        <Grid item  xs={6} sm={6} md={2} lg={1.5} xl={1}> 
          <Button
            fullWidth
            size="small"
            color='primary'
            variant='contained'
            disableElevation
            onClick={aoClicarEmNovo}
            startIcon={<Icon>add</Icon>}
            sx={{
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              fontWeight: 'bold',
              '&:hover': {
                background: `linear-gradient(45deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[4],
              }
            }}
          >
            adicionar
          </Button>
        </Grid> 
        <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1}> 
          <Button 
            size="small"
            fullWidth
            color='success'
            variant='contained'
            disabled={disbilitarBaixar}
            disableElevation
            onClick={aoClicarEmBaixa}
            startIcon={<Icon>paid</Icon>}
            sx={{
              background: `linear-gradient(45deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
              fontWeight: 'bold',
              '&:hover': {
                background: `linear-gradient(45deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[4],
              }
            }}
          >
            Baixar
          </Button>
        </Grid> 
        {mostrarBotaoCheque && (
          <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1}> 
            <Button 
              size="small"
              fullWidth
              color='info'
              variant='contained'
              disableElevation
              disabled={disbilitarCheque}
              onClick={aoClicarEmCheque}
              startIcon={<Icon>payment</Icon>}
              sx={{
                background: `linear-gradient(45deg, ${theme.palette.info.main} 0%, ${theme.palette.info.dark} 100%)`,
                fontWeight: 'bold',
                '&:hover': {
                  background: `linear-gradient(45deg, ${theme.palette.info.dark} 0%, ${theme.palette.info.main} 100%)`,
                  transform: 'translateY(-1px)',
                  boxShadow: theme.shadows[4],
                }
              }}
            >
               Cheque
            </Button>              
          </Grid> 
        )}
        <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1}> 
          <Button
            size="small"
            fullWidth
            color='primary'
            disableElevation
            variant='outlined'
            disabled={disbilitarImprimir}
            onClick={aoClicarEmImpressao}
            startIcon={<Icon>print</Icon>}
            sx={{
              fontWeight: 'bold',
              borderColor: alpha(theme.palette.primary.main, 0.5),
              color: theme.palette.primary.main,
              '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: alpha(theme.palette.primary.main, 0.08),
                transform: 'translateY(-1px)',
              }
            }}
          >
             Imprimir
          </Button>
        </Grid>    
      </Grid> 
    </Box>
  );
};